import React, { useState, useEffect } from 'react';
import './Contact.css';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    interest: 'Apartments',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const storedSubject = window.localStorage.getItem('enquiry_subject');
    if (storedSubject) {
      setFormData(prev => ({
        ...prev,
        message: `${storedSubject}. I would like to request more details and a brochure.`
      }));
      window.localStorage.removeItem('enquiry_subject');
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Format the WhatsApp message
    const text = `Hi, I have an enquiry.%0A- Name: ${formData.name}%0A- Email: ${formData.email}%0A- Phone: ${formData.phone}%0A- Interested In: ${formData.interest}%0A- Message: ${formData.message}`;
    const whatsappUrl = `https://wa.me/919099999149?text=${text}`;
    
    // Open WhatsApp link in a new tab
    window.open(whatsappUrl, '_blank');

    setSubmitted(true);
    setFormData({
      name: '',
      email: '',
      phone: '',
      interest: 'Apartments',
      message: ''
    });
  };

  return (
    <div className="contact-page animate-fade-in-up">
      {/* Page Header */}
      <section className="page-header">
        <div className="container text-center">
          <span className="section-tag" style={{ backgroundColor: 'var(--color-accent-light)', color: 'var(--color-accent)' }}>
            Connect With Us
          </span>
          <h1 className="page-title">Contact Office</h1>
          <p className="page-subtitle">
            Let us help you choose your dream space. Reach out to our Sales and Support desk today.
          </p>
        </div>
      </section>

      {/* Main Grid: Form & Info */}
      <section className="contact-grid-section">
        <div className="container">
          <div className="grid-2">
            {/* Form */}
            <div className="premium-card contact-form-card">
              {submitted ? (
                <div className="success-state text-center" style={{ padding: '40px 0' }}>
                  <div className="success-icon" style={{ fontSize: '3rem', color: 'var(--color-accent)', marginBottom: '20px' }}>✓</div>
                  <h2 style={{ marginBottom: '10px' }}>Thank You!</h2>
                  <p>Your enquiry has been received successfully. One of our property consultants will call you within 2-4 business hours.</p>
                  <button className="btn btn-primary" onClick={() => setSubmitted(false)} style={{ marginTop: '20px' }}>
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <h3 style={{ fontSize: '1.8rem', marginBottom: '25px' }}>Project Enquiry Form</h3>
                  
                  <div className="form-group">
                    <label htmlFor="name">Full Name</label>
                    <input 
                      type="text" 
                      id="name" 
                      name="name" 
                      required 
                      value={formData.name} 
                      onChange={handleChange}
                      placeholder="Enter your full name"
                    />
                  </div>

                  <div className="form-group-row">
                    <div className="form-group">
                      <label htmlFor="email">Email Address</label>
                      <input 
                        type="email" 
                        id="email" 
                        name="email" 
                        required 
                        value={formData.email} 
                        onChange={handleChange}
                        placeholder="yourname@gmail.com"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="phone">Phone Number</label>
                      <input 
                        type="tel" 
                        id="phone" 
                        name="phone" 
                        required 
                        value={formData.phone} 
                        onChange={handleChange}
                        placeholder="+91 XXXXX XXXXX"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="interest">Interested In</label>
                    <select 
                      id="interest" 
                      name="interest" 
                      value={formData.interest} 
                      onChange={handleChange}
                    >
                      <option value="Apartments">Apartments</option>
                      <option value="Open Plots">Open Plots</option>
                      <option value="Villa Plots">Villa Plots</option>
                      <option value="Premium Villa Plots">Premium Villa Plots</option>
                      <option value="Investment Plots">Investment Plots</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Your Message / Requirements</label>
                    <textarea 
                      id="message" 
                      name="message" 
                      rows="4" 
                      required 
                      value={formData.message} 
                      onChange={handleChange}
                      placeholder="Tell us about your requirements (e.g. budget, BHK preference, specific project, etc.)"
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-primary w-full" style={{ marginTop: '10px' }}>
                    Submit Enquiry & Request Callback
                  </button>
                </form>
              )}
            </div>

            {/* Info Cards */}
            <div className="contact-info-container">
              <div className="premium-card contact-info-card">
                <h3>Corporate Headquarters</h3>
                <p style={{ marginTop: '15px' }}>
                  📍 <strong>Skyon Infra Developers</strong><br />
                  Samathapuri Colony, Samathapuri,<br />
                  Nagole, Hyderabad, Telangana - 500068
                </p>
                <div style={{ marginTop: '25px' }}>
                  <p>📞 <strong>Sales Hotline:</strong> +91 90999 99149</p>
                  <p>📞 <strong>Corporate Desk:</strong> +91 93466 03168</p>
                  <p>✉ <strong>General Email:</strong> info@skyoninfradevelopers.com</p>
                  <p>✉ <strong>Sales Desk:</strong> sales@skyoninfradevelopers.com</p>
                </div>
              </div>

              <div className="premium-card contact-info-card" style={{ marginTop: '30px' }}>
                <h3>Office Working Hours</h3>
                <table className="working-hours-table" style={{ width: '100%', marginTop: '15px', borderCollapse: 'collapse' }}>
                  <tbody>
                    <tr>
                      <td style={{ padding: '8px 0', borderBottom: '1px solid var(--color-border)' }}>Monday - Saturday</td>
                      <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600', borderBottom: '1px solid var(--color-border)' }}>10:00 AM - 6:00 PM</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px 0' }}>Sunday</td>
                      <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600', color: 'var(--color-secondary)' }}>Closed</td>
                    </tr>
                  </tbody>
                </table>
                <p style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)', marginTop: '10px' }}>
                  * Site visits on Sundays must be scheduled in advance.
                </p>
              </div>

              <div className="premium-card contact-info-card" style={{ marginTop: '30px' }}>
                <h3>Connect With Us</h3>
                <p style={{ fontSize: '0.9rem', color: 'var(--color-text-muted)', marginTop: '10px', marginBottom: '15px' }}>
                  Follow us on our social media channels to stay updated on our latest projects.
                </p>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <a href="https://www.facebook.com/profile.php?id=61590403179487" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-primary-dark)', transition: '0.3s' }} onMouseOver={e => e.currentTarget.style.color='var(--color-secondary)'} onMouseOut={e => e.currentTarget.style.color='var(--color-primary-dark)'}>
                    <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
                  </a>
                  {/* WhatsApp Link */}
                  <a href="https://wa.me/919099999149" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-primary-dark)', transition: '0.3s' }} onMouseOver={e => e.currentTarget.style.color='var(--color-secondary)'} onMouseOut={e => e.currentTarget.style.color='var(--color-primary-dark)'}>
                    <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                  </a>
                  <a href="https://www.instagram.com/skyoninfra/?fbclid=IwY2xjawS9bKhleHRuA2FlbQIxMQBicmlkETF5N3kwbTF1YzdDVGpKbmJ4c3J0YwZhcHBfaWQBMAABHtHurJg-AAMaf2ezMEeN9ApbI34yrEWu1iIjMTW-H9P4gLK-7KLjWKqZwwiF_aem_IM-VjHkrcVevx_D40Pr3rQ" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-primary-dark)', transition: '0.3s' }} onMouseOver={e => e.currentTarget.style.color='var(--color-secondary)'} onMouseOut={e => e.currentTarget.style.color='var(--color-primary-dark)'}>
                    <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                  </a>
                  <a href="https://www.youtube.com/@SKYONINFRADEVELOPERS" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-primary-dark)', transition: '0.3s' }} onMouseOver={e => e.currentTarget.style.color='var(--color-secondary)'} onMouseOut={e => e.currentTarget.style.color='var(--color-primary-dark)'}>
                    <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33 2.78 2.78 0 0 0 1.94 2c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
